import React, { useState } from "react";
import rs_mall_cover from "../images/projects/rs_mall_cover.png";
import rs_mall_location from "../images/projects/rs_mall_location.png";
import rs_mall_profile from "../images/projects/rs_mall_profile.png";
import { Helmet } from "react-helmet";

const RSMall = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("shops");

  // ----- COMPLETE PRICE DATA EXTRACTED FROM PDF -----
  const priceData = {
    lowerGround: [
      {
        unit: "1",
        dim: '29-0"×14-5"',
        area: 420.5,
        priceSqft: 85000,
        total: 35742500,
        down: 8935625,
        install: 2233906,
      },
      {
        unit: "2",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 85000,
        total: 28594000,
        down: 7148500,
        install: 1787125,
      },
      {
        unit: "3",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 85000,
        total: 28594000,
        down: 7148500,
        install: 1787125,
      },
      {
        unit: "4",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 85000,
        total: 28594000,
        down: 7148500,
        install: 1787125,
      },
      {
        unit: "5",
        dim: '29-0"×16-6"',
        area: 381.4,
        priceSqft: 85000,
        total: 32419000,
        down: 8104750,
        install: 2026188,
      },
      {
        unit: "6",
        dim: '29-0"×16-6"',
        area: 381.4,
        priceSqft: 85000,
        total: 32419000,
        down: 8104750,
        install: 2026188,
      },
      {
        unit: "7",
        dim: '29-0"×17-0"',
        area: 493.0,
        priceSqft: 85000,
        total: 41905000,
        down: 10476250,
        install: 2619063,
      },
      {
        unit: "8",
        dim: '29-0"×12-6"',
        area: 365.4,
        priceSqft: 85000,
        total: 31059000,
        down: 7764750,
        install: 1941188,
      },
      {
        unit: "9",
        dim: '29-0"×12-6"',
        area: 365.4,
        priceSqft: 85000,
        total: 31059000,
        down: 7764750,
        install: 1941188,
      },
      {
        unit: "10",
        dim: '13-9"×14-0"',
        area: 194.6,
        priceSqft: 85000,
        total: 16541000,
        down: 4135250,
        install: 1033813,
      },
      {
        unit: "11",
        dim: '13-9"×14-0"',
        area: 194.6,
        priceSqft: 85000,
        total: 16541000,
        down: 4135250,
        install: 1033813,
      },
      {
        unit: "12",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 85000,
        total: 12019000,
        down: 3004750,
        install: 751188,
      },
      {
        unit: "13",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 85000,
        total: 12019000,
        down: 3004750,
        install: 751188,
      },
      {
        unit: "14",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 85000,
        total: 12019000,
        down: 3004750,
        install: 751188,
      },
      {
        unit: "15",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 85000,
        total: 12019000,
        down: 3004750,
        install: 751188,
      },
      {
        unit: "16",
        dim: '45-0"×12-6"',
        area: 500.0,
        priceSqft: 85000,
        total: 42500000,
        down: 10625000,
        install: 2656250,
      },
      {
        unit: "17",
        dim: '45-0"×12-6"',
        area: 500.0,
        priceSqft: 85000,
        total: 42500000,
        down: 10625000,
        install: 2656250,
      },
      {
        unit: "18",
        dim: '45-0"×17-0"',
        area: 747.0,
        priceSqft: 85000,
        total: 63495000,
        down: 15873750,
        install: 3968438,
      },
      {
        unit: "19",
        dim: '45-0"×11-6"',
        area: 522.0,
        priceSqft: 85000,
        total: 44370000,
        down: 11092500,
        install: 2773125,
      },
      {
        unit: "20",
        dim: '45-0"×11-6"',
        area: 522.0,
        priceSqft: 85000,
        total: 44370000,
        down: 11092500,
        install: 2773125,
      },
      {
        unit: "21",
        dim: '45-0"×11-6"',
        area: 522.0,
        priceSqft: 85000,
        total: 44370000,
        down: 11092500,
        install: 2773125,
      },
      {
        unit: "22",
        dim: '45-0"×14-5"',
        area: 652.5,
        priceSqft: 85000,
        total: 55462500,
        down: 13865625,
        install: 3466406,
      },
    ],
    groundFloor: [
      {
        unit: "1",
        dim: '29-0"×14-5"',
        area: 420.5,
        priceSqft: 100000,
        total: 42050000,
        down: 10512500,
        install: 2628125,
      },
      {
        unit: "2",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 95000,
        total: 31958000,
        down: 7989500,
        install: 1997375,
      },
      {
        unit: "3",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 95000,
        total: 31958000,
        down: 7989500,
        install: 1997375,
      },
      {
        unit: "4",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 95000,
        total: 31958000,
        down: 7989500,
        install: 1997375,
      },
      {
        unit: "5",
        dim: '29-0"×16-6"',
        area: 381.4,
        priceSqft: 95000,
        total: 36233000,
        down: 9058250,
        install: 2264563,
      },
      {
        unit: "6",
        dim: '29-0"×16-6"',
        area: 381.4,
        priceSqft: 95000,
        total: 36233000,
        down: 9058250,
        install: 2264563,
      },
      {
        unit: "7",
        dim: '29-0"×11-6"',
        area: 336.4,
        priceSqft: 95000,
        total: 31958000,
        down: 7989500,
        install: 1997375,
      },
      {
        unit: "8",
        dim: '29-0"×12-6"',
        area: 365.4,
        priceSqft: 95000,
        total: 34713000,
        down: 8678250,
        install: 2169563,
      },
      {
        unit: "9",
        dim: '29-0"×12-6"',
        area: 365.4,
        priceSqft: 95000,
        total: 34713000,
        down: 8678250,
        install: 2169563,
      },
      {
        unit: "10",
        dim: '13-9"×14-0"',
        area: 194.6,
        priceSqft: 95000,
        total: 18487000,
        down: 4621750,
        install: 1155438,
      },
      {
        unit: "11",
        dim: '13-9"×14-0"',
        area: 194.6,
        priceSqft: 95000,
        total: 18487000,
        down: 4621750,
        install: 1155438,
      },
      {
        unit: "12",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 95000,
        total: 13433000,
        down: 3358250,
        install: 839563,
      },
      {
        unit: "13",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 95000,
        total: 13433000,
        down: 3358250,
        install: 839563,
      },
      {
        unit: "14",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 95000,
        total: 13433000,
        down: 3358250,
        install: 839563,
      },
      {
        unit: "15",
        dim: '10-10"×14-0"',
        area: 141.4,
        priceSqft: 95000,
        total: 13433000,
        down: 3358250,
        install: 839563,
      },
      {
        unit: "16",
        dim: '45-0"×11-0"',
        area: 500.0,
        priceSqft: 95000,
        total: 47500000,
        down: 11875000,
        install: 2968750,
      },
      {
        unit: "17",
        dim: '45-0"×11-0"',
        area: 500.0,
        priceSqft: 95000,
        total: 47500000,
        down: 11875000,
        install: 2968750,
      },
    ],
    firstFloor: [
      {
        unit: "1",
        dim: '29.0"×14.5"',
        area: 420.5,
        priceSqft: 73000,
        total: 30696500,
        down: 7674125,
        install: 1918531,
      },
      {
        unit: "2",
        dim: '29.0"×11.6"',
        area: 336.4,
        priceSqft: 73000,
        total: 24557200,
        down: 6139300,
        install: 1534825,
      },
      {
        unit: "3",
        dim: '29.0"×11.6"',
        area: 336.4,
        priceSqft: 73000,
        total: 24557200,
        down: 6139300,
        install: 1534825,
      },
      {
        unit: "4",
        dim: '29.0"×11.6"',
        area: 336.4,
        priceSqft: 73000,
        total: 24557200,
        down: 6139300,
        install: 1534825,
      },
      {
        unit: "5",
        dim: '29.0"×16.6"',
        area: 481.4,
        priceSqft: 73000,
        total: 35142200,
        down: 8785550,
        install: 2196388,
      },
      {
        unit: "6",
        dim: '29.0"×13.6"',
        area: 398.0,
        priceSqft: 73000,
        total: 29054000,
        down: 7263500,
        install: 1815875,
      },
      {
        unit: "6-A",
        dim: '8.6"×12.6"',
        area: 108.3,
        priceSqft: 73000,
        total: 7905900,
        down: 1976475,
        install: 494119,
      },
      {
        unit: "7",
        dim: '29.0"×12.6"',
        area: 365.4,
        priceSqft: 73000,
        total: 26674200,
        down: 6668550,
        install: 1667138,
      },
      {
        unit: "8",
        dim: '14.6"×12.6"',
        area: 183.9,
        priceSqft: 73000,
        total: 13424700,
        down: 3356175,
        install: 839044,
      },
      {
        unit: "8-A",
        dim: '14.6"×12.6"',
        area: 183.9,
        priceSqft: 73000,
        total: 13424700,
        down: 3356175,
        install: 839044,
      },
      {
        unit: "9",
        dim: '14.3"×13.0"',
        area: 185.9,
        priceSqft: 73000,
        total: 13570700,
        down: 3392675,
        install: 848169,
      },
      {
        unit: "10",
        dim: '14.3"×13.0"',
        area: 185.9,
        priceSqft: 73000,
        total: 13570700,
        down: 3392675,
        install: 848169,
      },
      {
        unit: "12",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 73000,
        total: 9584900,
        down: 2396225,
        install: 599056,
      },
      {
        unit: "13",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 73000,
        total: 9584900,
        down: 2396225,
        install: 599056,
      },
      {
        unit: "14",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 73000,
        total: 9584900,
        down: 2396225,
        install: 599056,
      },
      {
        unit: "15",
        dim: '11.3"×11.3"',
        area: 127.7,
        priceSqft: 73000,
        total: 9321370,
        down: 2330343,
        install: 582586,
      },
      {
        unit: "16",
        dim: '11.3"×11.3"',
        area: 127.7,
        priceSqft: 73000,
        total: 9321370,
        down: 2330343,
        install: 582586,
      },
      {
        unit: "17",
        dim: '11.3"×11.3"',
        area: 127.7,
        priceSqft: 73000,
        total: 9321370,
        down: 2330343,
        install: 582586,
      },
      {
        unit: "18",
        dim: '11.3"×11.3"',
        area: 127.7,
        priceSqft: 73000,
        total: 9321370,
        down: 2330343,
        install: 582586,
      },
      {
        unit: "19",
        dim: '45.0"×11.4.5"',
        area: 513.0,
        priceSqft: 73000,
        total: 37449000,
        down: 9362250,
        install: 2340563,
      },
      {
        unit: "20",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 73000,
        total: 8299370,
        down: 2074843,
        install: 518711,
      },
      {
        unit: "21",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 73000,
        total: 8299370,
        down: 2074843,
        install: 518711,
      },
      {
        unit: "22",
        dim: '11.3"×11.3"',
        area: 127.6,
        priceSqft: 73000,
        total: 9314800,
        down: 2328700,
        install: 582175,
      },
      {
        unit: "23",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 73000,
        total: 8299370,
        down: 2074843,
        install: 518711,
      },
      {
        unit: "24",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 73000,
        total: 8299370,
        down: 2074843,
        install: 518711,
      },
      {
        unit: "25",
        dim: '45.0"×11.6"',
        area: 495.0,
        priceSqft: 73000,
        total: 36135000,
        down: 9033750,
        install: 2258438,
      },
      {
        unit: "26",
        dim: '45.0"×11.6"',
        area: 495.0,
        priceSqft: 73000,
        total: 36135000,
        down: 9033750,
        install: 2258438,
      },
      {
        unit: "27",
        dim: '45.0"×11.6"',
        area: 522.0,
        priceSqft: 73000,
        total: 38106000,
        down: 9526500,
        install: 2381625,
      },
      {
        unit: "28",
        dim: '45.0"×14.5"',
        area: 652.5,
        priceSqft: 73000,
        total: 47632500,
        down: 11908125,
        install: 2977031,
      },
    ],
    foodCourt: [
      {
        unit: "1",
        dim: '29.0"×11.6"',
        area: 336.4,
        priceSqft: 83000,
        total: 27921200,
        down: 6980300,
        install: 1745075,
      },
      {
        unit: "2",
        dim: '29.0"×11.6"',
        area: 336.4,
        priceSqft: 83000,
        total: 27921200,
        down: 6980300,
        install: 1745075,
      },
      {
        unit: "3",
        dim: '29.0"×16.6"',
        area: 381.4,
        priceSqft: 83000,
        total: 31656200,
        down: 7914050,
        install: 1978513,
      },
      {
        unit: "4",
        dim: '29.0"×13.6"',
        area: 398.0,
        priceSqft: 83000,
        total: 33034000,
        down: 8258500,
        install: 2064625,
      },
      {
        unit: "5-A",
        dim: '8.6"×12.6"',
        area: 108.3,
        priceSqft: 83000,
        total: 8988900,
        down: 2247225,
        install: 561806,
      },
      {
        unit: "6",
        dim: '29.0"×12.6"',
        area: 365.4,
        priceSqft: 83000,
        total: 30328200,
        down: 7582050,
        install: 1895513,
      },
      {
        unit: "7",
        dim: '14.6"×12.6"',
        area: 183.9,
        priceSqft: 83000,
        total: 15263700,
        down: 3815925,
        install: 953981,
      },
      {
        unit: "8-A",
        dim: '14.6"×12.6"',
        area: 183.9,
        priceSqft: 83000,
        total: 15263700,
        down: 3815925,
        install: 953981,
      },
      {
        unit: "9",
        dim: '14.3"×13.0"',
        area: 185.9,
        priceSqft: 83000,
        total: 15429700,
        down: 3857425,
        install: 964356,
      },
      {
        unit: "10",
        dim: '14.3"×13.0"',
        area: 185.9,
        priceSqft: 83000,
        total: 15429700,
        down: 3857425,
        install: 964356,
      },
      {
        unit: "11",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 83000,
        total: 10897900,
        down: 2724475,
        install: 681119,
      },
      {
        unit: "12",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 83000,
        total: 10897900,
        down: 2724475,
        install: 681119,
      },
      {
        unit: "13",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 83000,
        total: 10897900,
        down: 2724475,
        install: 681119,
      },
      {
        unit: "14",
        dim: '10.0"×13.0"',
        area: 131.3,
        priceSqft: 83000,
        total: 10897900,
        down: 2724475,
        install: 681119,
      },
      {
        unit: "15",
        dim: '11.3"×11.3"',
        area: 127.6,
        priceSqft: 83000,
        total: 10590800,
        down: 2647700,
        install: 661925,
      },
      {
        unit: "16",
        dim: '11.3"×11.3"',
        area: 127.6,
        priceSqft: 83000,
        total: 10590800,
        down: 2647700,
        install: 661925,
      },
      {
        unit: "17",
        dim: '11.3"×11.3"',
        area: 127.6,
        priceSqft: 83000,
        total: 10590800,
        down: 2647700,
        install: 661925,
      },
      {
        unit: "18",
        dim: '11.3"×11.3"',
        area: 127.6,
        priceSqft: 83000,
        total: 10590800,
        down: 2647700,
        install: 661925,
      },
      {
        unit: "19",
        dim: '45.0"×11.4.5"',
        area: 513.0,
        priceSqft: 83000,
        total: 42579000,
        down: 10644750,
        install: 2661188,
      },
      {
        unit: "20",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 83000,
        total: 9436270,
        down: 2359068,
        install: 589767,
      },
      {
        unit: "21",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 83000,
        total: 9436270,
        down: 2359068,
        install: 589767,
      },
      {
        unit: "22",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 83000,
        total: 9436270,
        down: 2359068,
        install: 589767,
      },
      {
        unit: "23",
        dim: '11.3"×10.0"',
        area: 113.7,
        priceSqft: 83000,
        total: 9436270,
        down: 2359068,
        install: 589767,
      },
      {
        unit: "24",
        dim: '45.0"×11.6"',
        area: 495.0,
        priceSqft: 83000,
        total: 41085000,
        down: 10271250,
        install: 2567813,
      },
      {
        unit: "25",
        dim: '45.0"×11.6"',
        area: 495.0,
        priceSqft: 83000,
        total: 41085000,
        down: 10271250,
        install: 2567813,
      },
    ],
    offices: [
      {
        unit: "1",
        area: 706.89,
        priceSqft: 23000,
        total: 16258470,
        down: 4064618,
        install: 1016154,
      },
      {
        unit: "2",
        area: 656.82,
        priceSqft: 23000,
        total: 15106860,
        down: 3776715,
        install: 944179,
      },
      {
        unit: "3",
        area: 707.61,
        priceSqft: 23000,
        total: 16275030,
        down: 4068758,
        install: 1017189,
      },
      {
        unit: "4",
        area: 670.72,
        priceSqft: 23000,
        total: 15426560,
        down: 3856640,
        install: 964160,
      },
      {
        unit: "5",
        area: 669.08,
        priceSqft: 23000,
        total: 15388840,
        down: 3847210,
        install: 961803,
      },
      {
        unit: "6",
        area: 690.28,
        priceSqft: 23000,
        total: 15876440,
        down: 3969110,
        install: 992278,
      },
      {
        unit: "7",
        area: 746.77,
        priceSqft: 23000,
        total: 17175710,
        down: 4293928,
        install: 1073482,
      },
      {
        unit: "8",
        area: 690.66,
        priceSqft: 23000,
        total: 15885180,
        down: 3971295,
        install: 992824,
      },
      {
        unit: "9",
        area: 683.25,
        priceSqft: 23000,
        total: 15714750,
        down: 3928688,
        install: 982172,
      },
      {
        unit: "10",
        area: 982.81,
        priceSqft: 23000,
        total: 22604630,
        down: 5651158,
        install: 1412789,
      },
      {
        unit: "11",
        area: 1123.59,
        priceSqft: 23000,
        total: 25842570,
        down: 6460643,
        install: 1615161,
      },
      {
        unit: "12",
        area: 1040.54,
        priceSqft: 23000,
        total: 23932420,
        down: 5983105,
        install: 1495776,
      },
      {
        unit: "13",
        area: 834.71,
        priceSqft: 23000,
        total: 19198330,
        down: 4799583,
        install: 1199896,
      },
      {
        unit: "14",
        area: 834.71,
        priceSqft: 23000,
        total: 19198330,
        down: 4799583,
        install: 1199896,
      },
      {
        unit: "15",
        area: 510.3,
        priceSqft: 23000,
        total: 11736900,
        down: 2934225,
        install: 733556,
      },
      {
        unit: "16",
        area: 511.86,
        priceSqft: 23000,
        total: 11772780,
        down: 2943195,
        install: 735799,
      },
      {
        unit: "17",
        area: 738.37,
        priceSqft: 23000,
        total: 16982510,
        down: 4245628,
        install: 1061407,
      },
    ],
    apartments: {
      fifth: [
        {
          unit: "1",
          area: 1592.68,
          category: "2-Bed",
          priceSqft: 19000,
          total: 30260920,
          down: 7565230,
          install: 1891308,
        },
        {
          unit: "2",
          area: 1500.0,
          category: "2-Bed",
          priceSqft: 19000,
          total: 28500000,
          down: 7125000,
          install: 1781250,
        },
        {
          unit: "3",
          area: 930.94,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17687860,
          down: 4421965,
          install: 1105491,
        },
        {
          unit: "4",
          area: 1629.35,
          category: "2-Bed",
          priceSqft: 19000,
          total: 30957650,
          down: 7739413,
          install: 1934853,
        },
        {
          unit: "5",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "6",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "7",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
        {
          unit: "8",
          area: 946.56,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17984640,
          down: 4496160,
          install: 1124040,
        },
      ],
      sixth: [
        {
          unit: "1",
          area: 1677.21,
          category: "2-Bed",
          priceSqft: 19000,
          total: 31866990,
          down: 7966748,
          install: 1991687,
        },
        {
          unit: "2",
          area: 1500.0,
          category: "2-Bed",
          priceSqft: 19000,
          total: 28500000,
          down: 7125000,
          install: 1781250,
        },
        {
          unit: "3",
          area: 930.94,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17687860,
          down: 4421965,
          install: 1105491,
        },
        {
          unit: "4",
          area: 1629.35,
          category: "2-Bed",
          priceSqft: 19000,
          total: 30957650,
          down: 7739413,
          install: 1934853,
        },
        {
          unit: "5",
          area: 1773.14,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33689660,
          down: 8422415,
          install: 2105604,
        },
        {
          unit: "6",
          area: 1760.49,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33449310,
          down: 8362328,
          install: 2090582,
        },
        {
          unit: "7",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "8",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "9",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
        {
          unit: "10",
          area: 1599.24,
          category: "2-Bed",
          priceSqft: 19000,
          total: 30385560,
          down: 7596390,
          install: 1899098,
        },
      ],
      seventh: [
        {
          unit: "1",
          area: 944.31,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17941890,
          down: 4485473,
          install: 1121368,
        },
        {
          unit: "2",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
      ],
      eighth: [
        {
          unit: "1",
          area: 933.32,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17733080,
          down: 4433270,
          install: 1108318,
        },
        {
          unit: "2",
          area: 948.48,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18021120,
          down: 4505280,
          install: 1126320,
        },
        {
          unit: "3",
          area: 961.5,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18268500,
          down: 4567125,
          install: 1141781,
        },
        {
          unit: "4",
          area: 951.6,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18080400,
          down: 4520100,
          install: 1130025,
        },
        {
          unit: "5",
          area: 1042.8,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19813200,
          down: 4953300,
          install: 1238325,
        },
        {
          unit: "6",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
      ],
      ninth: [
        {
          unit: "1",
          area: 933.32,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17733080,
          down: 4433270,
          install: 1108318,
        },
        {
          unit: "2",
          area: 879.63,
          category: "1-Bed",
          priceSqft: 19000,
          total: 16712970,
          down: 4178243,
          install: 1044561,
        },
        {
          unit: "3",
          area: 982.97,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18676430,
          down: 4669108,
          install: 1167277,
        },
        {
          unit: "4",
          area: 948.48,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18021120,
          down: 4505280,
          install: 1126320,
        },
        {
          unit: "5",
          area: 961.5,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18268500,
          down: 4567125,
          install: 1141781,
        },
        {
          unit: "6",
          area: 951.6,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18080400,
          down: 4520100,
          install: 1130025,
        },
        {
          unit: "7",
          area: 1042.8,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19813200,
          down: 4953300,
          install: 1238325,
        },
        {
          unit: "8",
          area: 1760.95,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33458050,
          down: 8364513,
          install: 2091128,
        },
        {
          unit: "9",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
        {
          unit: "10",
          area: 868.84,
          category: "1-Bed",
          priceSqft: 19000,
          total: 16507960,
          down: 4126990,
          install: 1031748,
        },
        {
          unit: "11",
          area: 930.4,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17677600,
          down: 4419400,
          install: 1104850,
        },
      ],
      tenth: [
        {
          unit: "1",
          area: 931.02,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17689380,
          down: 4422345,
          install: 1105586,
        },
        {
          unit: "2",
          area: 933.32,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17733080,
          down: 4433270,
          install: 1108318,
        },
        {
          unit: "3",
          area: 879.63,
          category: "1-Bed",
          priceSqft: 19000,
          total: 16712970,
          down: 4178243,
          install: 1044561,
        },
        {
          unit: "4",
          area: 944.31,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17941890,
          down: 4485473,
          install: 1121368,
        },
        {
          unit: "5",
          area: 982.97,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18676430,
          down: 4669108,
          install: 1167277,
        },
        {
          unit: "6",
          area: 948.48,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18021120,
          down: 4505280,
          install: 1126320,
        },
        {
          unit: "7",
          area: 961.5,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18268500,
          down: 4567125,
          install: 1141781,
        },
        {
          unit: "8",
          area: 951.6,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18080400,
          down: 4520100,
          install: 1130025,
        },
        {
          unit: "9",
          area: 1042.8,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19813200,
          down: 4953300,
          install: 1238325,
        },
        {
          unit: "10",
          area: 1760.95,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33458050,
          down: 8364513,
          install: 2091128,
        },
        {
          unit: "11",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "12",
          area: 1042.07,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19799330,
          down: 4949833,
          install: 1237458,
        },
        {
          unit: "13",
          area: 1440.98,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27378620,
          down: 6844655,
          install: 1711164,
        },
        {
          unit: "14",
          area: 868.84,
          category: "1-Bed",
          priceSqft: 19000,
          total: 16507960,
          down: 4126990,
          install: 1031748,
        },
        {
          unit: "15",
          area: 930.4,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17677600,
          down: 4419400,
          install: 1104850,
        },
      ],
      eleventh: [
        {
          unit: "1",
          area: 2499.36,
          category: "Pent House",
          priceSqft: 0,
          total: 0,
          down: 0,
          install: 0,
        },
        {
          unit: "2",
          area: 1684.19,
          category: "2-Bed",
          priceSqft: 19000,
          total: 31999610,
          down: 7999903,
          install: 1999976,
        },
        {
          unit: "3",
          area: 1771.03,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33649570,
          down: 8412393,
          install: 2103098,
        },
        {
          unit: "4",
          area: 1700.0,
          category: "2-Bed",
          priceSqft: 19000,
          total: 32300000,
          down: 8075000,
          install: 2018750,
        },
        {
          unit: "5",
          area: 1101.63,
          category: "1-Bed",
          priceSqft: 19000,
          total: 20930970,
          down: 5232743,
          install: 1308186,
        },
        {
          unit: "6",
          area: 1044.71,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19849490,
          down: 4962373,
          install: 1240593,
        },
        {
          unit: "7",
          area: 1782.23,
          category: "Pent House",
          priceSqft: 0,
          total: 0,
          down: 0,
          install: 0,
        },
      ],
      twelfth: [
        {
          unit: "1",
          area: 1160.14,
          category: "1-Bed",
          priceSqft: 19000,
          total: 22042660,
          down: 5510665,
          install: 1377666,
        },
        {
          unit: "2",
          area: 943.53,
          category: "1-Bed",
          priceSqft: 19000,
          total: 17927070,
          down: 4481768,
          install: 1120442,
        },
        {
          unit: "3",
          area: 982.97,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18676430,
          down: 4669108,
          install: 1167277,
        },
        {
          unit: "4",
          area: 948.39,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18019410,
          down: 4504853,
          install: 1126213,
        },
        {
          unit: "5",
          area: 961.5,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18268500,
          down: 4567125,
          install: 1141781,
        },
        {
          unit: "6",
          area: 950.33,
          category: "1-Bed",
          priceSqft: 19000,
          total: 18056270,
          down: 4514068,
          install: 1128517,
        },
        {
          unit: "7",
          area: 1051.33,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19975270,
          down: 4993818,
          install: 1248454,
        },
      ],
      thirteenth: [
        {
          unit: "1",
          area: 1458.46,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27710740,
          down: 6927685,
          install: 1731921,
        },
        {
          unit: "2",
          area: 1557.41,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29590790,
          down: 7397698,
          install: 1849424,
        },
        {
          unit: "3",
          area: 1771.03,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33649570,
          down: 8412393,
          install: 2103098,
        },
        {
          unit: "4",
          area: 1101.63,
          category: "2-Bed",
          priceSqft: 19000,
          total: 20930970,
          down: 5232743,
          install: 1308186,
        },
        {
          unit: "5",
          area: 1044.71,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19849490,
          down: 4962373,
          install: 1240593,
        },
        {
          unit: "6",
          area: 1545.71,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29368490,
          down: 7342123,
          install: 1835531,
        },
      ],
      fourteenth: [
        {
          unit: "1",
          area: 1458.46,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27710740,
          down: 6927685,
          install: 1731921,
        },
        {
          unit: "2",
          area: 1557.41,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29590790,
          down: 7397698,
          install: 1849424,
        },
        {
          unit: "3",
          area: 1684.19,
          category: "2-Bed",
          priceSqft: 19000,
          total: 31999610,
          down: 7999903,
          install: 1999976,
        },
        {
          unit: "4",
          area: 1771.03,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33649570,
          down: 8412393,
          install: 2103098,
        },
        {
          unit: "5",
          area: 1101.63,
          category: "1-Bed",
          priceSqft: 19000,
          total: 20930970,
          down: 5232743,
          install: 1308186,
        },
        {
          unit: "6",
          area: 1044.71,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19849490,
          down: 4962373,
          install: 1240593,
        },
        {
          unit: "7",
          area: 1545.71,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29368490,
          down: 7342123,
          install: 1835531,
        },
      ],
      fifteenth: [
        {
          unit: "1",
          area: 1458.46,
          category: "2-Bed",
          priceSqft: 19000,
          total: 27710740,
          down: 6927685,
          install: 1731921,
        },
        {
          unit: "2",
          area: 1557.41,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29590790,
          down: 7397698,
          install: 1849424,
        },
        {
          unit: "3",
          area: 1684.19,
          category: "2-Bed",
          priceSqft: 19000,
          total: 31999610,
          down: 7999903,
          install: 1999976,
        },
        {
          unit: "4",
          area: 1771.03,
          category: "2-Bed",
          priceSqft: 19000,
          total: 33649570,
          down: 8412393,
          install: 2103098,
        },
        {
          unit: "5",
          area: 1101.63,
          category: "1-Bed",
          priceSqft: 19000,
          total: 20930970,
          down: 5232743,
          install: 1308186,
        },
        {
          unit: "6",
          area: 1044.71,
          category: "1-Bed",
          priceSqft: 19000,
          total: 19849490,
          down: 4962373,
          install: 1240593,
        },
        {
          unit: "7",
          area: 1545.71,
          category: "2-Bed",
          priceSqft: 19000,
          total: 29368490,
          down: 7342123,
          install: 1835531,
        },
      ],
    },
  };

  const whatsappLink = "https://wa.me/923487172565";

  const getTabData = () => {
    switch (activeTab) {
      case "shops":
        return [
          ...priceData.lowerGround,
          ...priceData.groundFloor,
          ...priceData.firstFloor,
        ];
      case "food":
        return priceData.foodCourt;
      case "offices":
        return priceData.offices;
      case "apartments":
        return Object.values(priceData.apartments).flat();
      default:
        return [];
    }
  };

  const currentData = getTabData();

  // Image placeholders using emoji/icons for visual appeal
  const buildingIcon = "🏢";
  const shopIcon = "🛍️";
  const foodIcon = "🍽️";
  const officeIcon = "💼";
  const apartmentIcon = "🏠";
  const penthouseIcon = "⭐";

  return (
    <div className="font-sans antialiased bg-white text-gray-800">
           <Helmet>
          <title>RS MALL & APARTMENTS | Premium Commercial Offices & Residential Appartments in G-13, Islamabad</title>
          <meta name="description" content="Invest in RS MALL & APARTMENTS in G-13, Islamabad. Premium commercial office spaces with flexible 25% down payment and 4 quarterly installments. Safe & secure investment in Islamabad." />
          <meta name="keywords" content="RS MALL & APARTMENTS, G-13 Islamabad, Commercial Offices, Real Estate Islamabad, Jinnah Avenue, Property Investment, Marketing & Developers, Office Space for Sale" />
          
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://estateghar.com/projects/rs-mall" />
          <meta property="og:title" content="RS MALL & APARTMENTS | Premium Commercial Offices & Residential Appartments in G-13, Islamabad" />
          <meta property="og:description" content="RS MALL & APARTMENTS offers premium commercial office spaces in the heart of Islamabad. Secure your investment with a 25% down payment today." />
          <meta property="og:image" content={rs_mall_profile} />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content="https://estateghar.com/projects/rs-mall" />
          <meta property="twitter:title" content="RS MALL & APARTMENTS | Premium Commercial Offices & Residential Appartments in G-13, Islamabad" />
          <meta property="twitter:description" content="RS MALL & APARTMENTS offers premium commercial office spaces in the heart of Islamabad. Secure your investment with a 25% down payment today." />
          <meta property="twitter:image" content={rs_mall_profile} />
          
        </Helmet>
      {/* ----- HERO SECTION WITH IMAGE ----- */}
      <header className="relative bg-gradient-to-br from-red-800 to-red-600 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj48cmVjdCB3aWR0aD0iODAiIGhlaWdodD0iODAiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNMzAgMTBhMjAgMjAgMCAwIDEgMjAgMjAgMjAgMjAgMCAwIDEtMjAgMjAgMjAgMjAgMCAwIDEtMjAtMjAgMjAgMjAgMCAwIDEgMjAtMjB6IiBmaWxsPSIjZmZmIi8+PC9zdmc+')] bg-repeat bg-[length:80px_80px]"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-24 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
          <div className="md:w-1/2 space-y-4 sm:space-y-6 text-center md:text-left">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-semibold tracking-wider">
              🏆 3 DECADES OF EXCELLENCE
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              RS MALL &amp; <br />
              <span className="text-yellow-300">APARTMENTS</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-red-100">
              “Luxury all around” · Sector G-13, Islamabad
            </p>
            <p className="text-sm sm:text-base text-red-200/90 max-w-lg mx-auto md:mx-0">
              Iconic mixed-use high‑rise · Shops · Offices · 1‑Bed &amp; 2‑Bed
              Apartments
            </p>
            <div className="flex flex-wrap gap-3 sm:gap-4 justify-center md:justify-start pt-2">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-red-700 px-5 sm:px-8 py-2.5 sm:py-4 rounded-full font-bold text-sm sm:text-lg shadow-lg hover:bg-red-50 transition-all hover:scale-105 active:scale-95"
              >
                <svg
                  className="w-4 h-4 sm:w-6 sm:h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Book Now
              </a>
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center gap-2 bg-red-700/30 backdrop-blur-sm border-2 border-white/60 text-white px-5 sm:px-8 py-2.5 sm:py-4 rounded-full font-bold text-sm sm:text-lg hover:bg-red-700/50 transition-all active:scale-95"
              >
                <svg
                  className="w-4 h-4 sm:w-5 sm:h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12h6m-6 4h6m2-10h-4a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2h8a2 2 0 002-2v-6a2 2 0 00-2-2h-4a2 2 0 01-2-2V6a2 2 0 012-2z"
                  />
                </svg>
                Payment Plan
              </button>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <div className="bg-white/10 backdrop-blur-sm p-3 sm:p-4 rounded-2xl shadow-2xl border border-white/20 relative">
              <div className="w-40 h-40 sm:w-56 sm:h-56 md:w-64 md:h-64 rounded-xl bg-gradient-to-br from-red-400 to-red-800 flex flex-col items-center justify-center text-white font-bold shadow-inner">
                <img
                  src={rs_mall_cover}
                  alt="RS Mall Logo"
                  className="w-20 rounded-md sm:w-28 md:w-32 mb-2"
                />
                <span className="text-lg sm:text-2xl mt-1 sm:mt-2 font-extrabold">
                  RS MALL
                </span>
                <span className="text-xs sm:text-sm text-red-200">
                  G-13 Islamabad
                </span>
                <span className="text-[10px] sm:text-xs text-red-300/80 mt-1">
                  Luxury all around
                </span>
              </div>
              <div className="absolute -bottom-2 -right-2 bg-yellow-400 text-red-900 text-[10px] sm:text-xs font-bold px-2 sm:px-3 py-0.5 sm:py-1 rounded-full shadow-lg">
                We Deliver
              </div>
            </div>
          </div>
        </div>
        <div className="relative h-1 bg-yellow-300/50"></div>
      </header>

      <section className="max-w-7xl mx-auto flex flex-col justify-center px-4 py-6 sm:py-8">
        <img
          src={rs_mall_cover}
          alt="RS Mall Hero"
          className="w-auto h-auto sm:h-80 object-center object-cover rounded-2xl shadow-lg mx-auto mb-4 sm:mb-6"
        />
        <div className="text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-red-800 mb-2">
            RS Mall &amp; Apartments
          </h2>
          <p className="text-sm sm:text-base text-gray-700 max-w-2xl mx-auto">
            A landmark of modern living in G-13/4, Islamabad. 3 floors of car
            parking, lower ground + ground + 2 floors of branded shops,
            dedicated food court, 4th-6th floor offices, and 7th-15th floor
            1‑bed &amp; 2‑bed apartments. Separate entrances for privacy and
            convenience.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-6 sm:py-8"> 
        <h1 className="text-2xl sm:text-3xl font-bold text-red-800 mb-2">
          Project Location Map
        </h1>
        <img src={rs_mall_location} alt="Project Location Map" className="w-full h-auto sm:h-80 object-center object-cover rounded-2xl shadow-lg mx-auto mb-4 sm:mb-6" />
      </section>

      {/* ----- STATS / MILESTONES WITH IMAGES ----- */}
      <section className="max-w-7xl mx-auto px-4 py-8 sm:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
          <div className="bg-red-50 p-3 sm:p-6 rounded-2xl border-l-8 border-red-700 shadow-sm text-center hover:shadow-md transition-shadow">
            <div className="text-3xl sm:text-5xl mb-1">🏗️</div>
            <div className="text-2xl sm:text-4xl font-bold text-red-800">
              30+
            </div>
            <p className="text-xs sm:text-sm text-gray-700">
              Years of Excellence
            </p>
          </div>
          <div className="bg-red-50 p-3 sm:p-6 rounded-2xl border-l-8 border-red-700 shadow-sm text-center hover:shadow-md transition-shadow">
            <div className="text-3xl sm:text-5xl mb-1">📐</div>
            <div className="text-2xl sm:text-4xl font-bold text-red-800">
              10M+
            </div>
            <p className="text-xs sm:text-sm text-gray-700">Sq.ft Delivered</p>
          </div>
          <div className="bg-red-50 p-3 sm:p-6 rounded-2xl border-l-8 border-red-700 shadow-sm text-center hover:shadow-md transition-shadow">
            <div className="text-3xl sm:text-5xl mb-1">🏘️</div>
            <div className="text-2xl sm:text-4xl font-bold text-red-800">
              50+
            </div>
            <p className="text-xs sm:text-sm text-gray-700">
              Complete Projects
            </p>
          </div>
          <div className="bg-red-50 p-3 sm:p-6 rounded-2xl border-l-8 border-red-700 shadow-sm text-center hover:shadow-md transition-shadow">
            <div className="text-3xl sm:text-5xl mb-1">✅</div>
            <div className="text-2xl sm:text-4xl font-bold text-red-800">
              100%
            </div>
            <p className="text-xs sm:text-sm text-gray-700">“We Deliver”</p>
          </div>
        </div>
      </section>

      {/* ----- ABOUT / PROJECT OVERVIEW WITH IMAGES ----- */}
      <section className="max-w-7xl mx-auto px-4 pb-8 sm:pb-12">
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 items-start">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-3xl">{buildingIcon}</span>
              <h2 className="text-2xl sm:text-3xl font-bold text-red-800 inline-block border-b-4 border-red-600 pb-2">
                RS Mall &amp; Apartments
              </h2>
            </div>
            <p className="mt-3 sm:mt-4 text-gray-700 leading-relaxed text-sm sm:text-base">
              <span className="font-semibold text-red-700">
                G-13/4, Islamabad
              </span>{" "}
              — a landmark of modern living. 3 floors of car parking, lower
              ground + ground + 2 floors of branded shops, dedicated food court,
              4th-6th floor offices, and 7th-15th floor 1‑bed &amp; 2‑bed
              apartments. Separate entrances for privacy and convenience.
            </p>
            <div className="mt-4 grid grid-cols-2 gap-2 text-xs sm:text-sm bg-red-50 p-3 sm:p-4 rounded-xl">
              <div className="flex items-center gap-2">
                <span className="text-lg">❄️</span> HVAC System
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">📏</span> 14’ Roof Height
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">🪜</span> Modern Escalators
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">🔒</span> Security System
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">🕌</span> Pray Area
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">👩</span> Ladies Common Room
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">🔥</span> Fire Fighting
              </div>
              <div className="flex items-center gap-2">
                <span className="text-lg">⚡</span> 24/7 Power Backup
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <div className="bg-red-50 p-4 sm:p-6 rounded-2xl border border-red-200">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-3xl">👨‍💼</span>
                <h4 className="text-base sm:text-xl font-bold text-red-800">
                  Chairman's Vision
                </h4>
              </div>
              <p className="text-gray-600 italic text-sm sm:text-base">
                “We deliver what we commit” — Mr. Shahid Chan Zeb
              </p>
              <p className="text-xs sm:text-sm text-gray-500 mt-3">
                Over 50 completed projects · Iconic Galleria · Capital Square ·
                The Arch
              </p>
            </div>
            <div className="bg-white p-3 sm:p-4 rounded-xl border border-red-100 shadow-sm">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-2xl">📍</span>
                <span className="font-semibold text-red-700 text-sm">
                  Achievements:
                </span>
              </div>
              <p className="text-xs sm:text-sm text-gray-600">
                G-6, G-8, G-10, G-11, G-13, G-14, D-12, D-17, E-11, H-13, Faisal
                Town, Bahria Enclave
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ----- COMPANY PROFILE WITH IMAGES ----- */}
      <section className="bg-red-50 py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-3 justify-center mb-6 sm:mb-8">
            <span className="text-3xl">🏛️</span>
            <h2 className="text-2xl sm:text-3xl font-bold text-red-800">
              Company Profile
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-red-100 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">🏢</span>
                <h3 className="font-bold text-red-700 text-sm sm:text-base">
                  Red Sun Associates
                </h3>
              </div>
              <p className="text-xs sm:text-sm text-gray-600">
                Over 3 decades of excellence in real estate, delivering iconic
                landmarks across twin cities. Built on trust, transparency, and
                integrity.
              </p>
            </div>
            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-red-100 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">🏗️</span>
                <h3 className="font-bold text-red-700 text-sm sm:text-base">
                  Key Projects
                </h3>
              </div>
              <ul className="text-xs sm:text-sm text-gray-600 space-y-1.5">
                <li className="flex items-start gap-2">
                  <span>•</span> The Galleria, Bahria Enclave (40 Kanals)
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span> Capital Square Mall, B-17 (550+ apts, 300
                  shops)
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span> The Gate Mall, Faisal Town (550 apts, 1000
                  shops)
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span> The Arch G-11 (200+ apartments)
                </li>
              </ul>
            </div>
            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-red-100 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">🏆</span>
                <h3 className="font-bold text-red-700 text-sm sm:text-base">
                  Achievements
                </h3>
              </div>
              <ul className="text-xs sm:text-sm text-gray-600 space-y-1.5">
                <li className="flex items-start gap-2">
                  <span>✅</span> 50+ completed projects
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> 10M+ sq.ft covered area
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> Delivered through Pandemic 19-21
                </li>
                <li className="flex items-start gap-2">
                  <span>✅</span> 100% commitment delivery
                </li>
              </ul>
            </div>
          </div>
        </div>
        <img src={rs_mall_profile} alt="RS Mall Cover" className="w-full h-auto sm:h-96 object-center object-cover rounded-2xl shadow-lg mx-auto mt-6 sm:mt-8" />
      </section>

      {/* ----- FLOOR PLAN / BUILDING FEATURES WITH IMAGES ----- */}
      <section className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex items-center gap-3 justify-center mb-6">
          <span className="text-3xl">📊</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-red-800">
            Building Overview
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 sm:p-4 rounded-xl text-center border border-red-200">
            <div className="text-3xl sm:text-4xl mb-1">🅿️</div>
            <div className="font-bold text-red-800 text-sm sm:text-base">
              3 Floors
            </div>
            <div className="text-xs text-gray-600">Car Parking</div>
          </div>
          <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 sm:p-4 rounded-xl text-center border border-red-200">
            <div className="text-3xl sm:text-4xl mb-1">{shopIcon}</div>
            <div className="font-bold text-red-800 text-sm sm:text-base">
              4 Floors
            </div>
            <div className="text-xs text-gray-600">
              Shopping &amp; Food Court
            </div>
          </div>
          <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 sm:p-4 rounded-xl text-center border border-red-200">
            <div className="text-3xl sm:text-4xl mb-1">{officeIcon}</div>
            <div className="font-bold text-red-800 text-sm sm:text-base">
              3 Floors
            </div>
            <div className="text-xs text-gray-600">Offices (4th-6th)</div>
          </div>
          <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 sm:p-4 rounded-xl text-center border border-red-200">
            <div className="text-3xl sm:text-4xl mb-1">{apartmentIcon}</div>
            <div className="font-bold text-red-800 text-sm sm:text-base">
              9 Floors
            </div>
            <div className="text-xs text-gray-600">Apartments (7th-15th)</div>
          </div>
        </div>
      </section>

      {/* ----- PRICE LIST CTA ----- */}
      <section className="bg-gradient-to-r from-red-700 to-red-800 py-10 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex items-center gap-3 justify-center mb-4">
            <span className="text-3xl">💰</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
              Complete Price List
            </h2>
          </div>
          <p className="text-red-100 mt-2 text-sm sm:text-base">
            Shops · Food Court · Offices · Apartments · Flexible Payment Plans
          </p>
          <button
            onClick={() => setShowModal(true)}
            className="mt-6 bg-white hover:bg-red-50 text-red-700 font-bold py-3 px-8 sm:px-12 rounded-full shadow-lg transition-all inline-flex items-center gap-2 text-sm sm:text-base active:scale-95"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h6m-6 4h6m2-10h-4a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2h8a2 2 0 002-2v-6a2 2 0 00-2-2h-4a2 2 0 01-2-2V6a2 2 0 012-2z"
              />
            </svg>
            View Full Payment Plan
          </button>
        </div>
      </section>

      {/* ----- MODAL (Payment Plan with Tabs) ----- */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/60 backdrop-blur-sm">
          <div className="bg-white rounded-2xl max-w-5xl w-full max-h-[98vh] overflow-y-auto shadow-2xl border border-red-200">
            <div className="sticky top-0 bg-white z-10 flex flex-wrap justify-between items-center p-3 sm:p-4 border-b border-red-200">
              <h3 className="text-base sm:text-2xl font-bold text-red-800 flex items-center gap-2">
                <span>📋</span> Payment Plan
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-red-700 text-2xl sm:text-3xl leading-none p-1"
              >
                ×
              </button>
            </div>
            <div className="p-3 sm:p-6">
              {/* Tabs with icons */}
              <div className="flex flex-wrap gap-1 sm:gap-2 mb-4 sm:mb-6 border-b border-gray-200 pb-2 sm:pb-3">
                <button
                  onClick={() => setActiveTab("shops")}
                  className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all flex items-center gap-1 sm:gap-2 ${
                    activeTab === "shops"
                      ? "bg-red-700 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <span>{shopIcon}</span> Shops (LG, G, 1st)
                </button>
                <button
                  onClick={() => setActiveTab("food")}
                  className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all flex items-center gap-1 sm:gap-2 ${
                    activeTab === "food"
                      ? "bg-red-700 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <span>{foodIcon}</span> Food Court
                </button>
                <button
                  onClick={() => setActiveTab("offices")}
                  className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all flex items-center gap-1 sm:gap-2 ${
                    activeTab === "offices"
                      ? "bg-red-700 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <span>{officeIcon}</span> Offices (4th-6th)
                </button>
                <button
                  onClick={() => setActiveTab("apartments")}
                  className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all flex items-center gap-1 sm:gap-2 ${
                    activeTab === "apartments"
                      ? "bg-red-700 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <span>{apartmentIcon}</span> Apartments (7th-15th)
                </button>
              </div>

              <div className="text-xs sm:text-sm text-gray-500 mb-3 flex flex-wrap gap-2">
                <span className="bg-red-100 px-2 py-1 rounded">
                  25% Downpayment
                </span>
                <span className="bg-red-100 px-2 py-1 rounded">
                  12 Quarterly Installments
                </span>
                <span className="text-gray-400">
                  | {currentData.length} units
                </span>
              </div>

              <div className="overflow-x-auto -mx-3 sm:mx-0">
                <table className="w-full text-xs sm:text-sm text-left border-collapse min-w-[700px]">
                  <thead className="bg-red-700 text-white">
                    <tr>
                      <th className="p-2 sm:p-3 border">Unit</th>
                      <th className="p-2 sm:p-3 border">Dim / Area</th>
                      <th className="p-2 sm:p-3 border">Category</th>
                      <th className="p-2 sm:p-3 border">Price/sqft</th>
                      <th className="p-2 sm:p-3 border">Total (PKR)</th>
                      <th className="p-2 sm:p-3 border">25% Down</th>
                      <th className="p-2 sm:p-3 border">Installment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.slice(0, 30).map((item, idx) => (
                      <tr
                        key={idx}
                        className={idx % 2 === 0 ? "bg-red-50/50" : "bg-white"}
                      >
                        <td className="p-2 sm:p-3 border font-medium">
                          {item.unit}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.dim || `${item.area} sqft`}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.category || "Shop"}
                          {item.category === "Pent House" && (
                            <span className="ml-1 text-yellow-500">⭐</span>
                          )}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.priceSqft > 0
                            ? item.priceSqft.toLocaleString()
                            : "—"}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.total > 0 ? item.total.toLocaleString() : "—"}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.down > 0 ? item.down.toLocaleString() : "—"}
                        </td>
                        <td className="p-2 sm:p-3 border">
                          {item.install > 0
                            ? item.install.toLocaleString()
                            : "—"}
                        </td>
                      </tr>
                    ))}
                    {currentData.length > 30 && (
                      <tr className="bg-gray-50">
                        <td
                          colSpan="7"
                          className="p-3 text-center text-gray-500 text-xs"
                        >
                          + {currentData.length - 30} more units available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="mt-4 text-xs text-gray-400 bg-gray-50 p-3 rounded border border-gray-200 flex items-start gap-2">
                <span className="text-lg">📌</span>
                <span>
                  Complete price list includes Lower Ground (22 units), Ground
                  Floor (17 units), 1st Floor (28 units), Food Court (25 units),
                  Offices (17 units), and Apartments (7th-15th floors with
                  1-Bed, 2-Bed &amp; Pent House). Pent house prices available on
                  request.
                </span>
              </div>

              <div className="mt-5 flex flex-col sm:flex-row justify-end gap-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-6 rounded-full transition text-sm"
                >
                  Close
                </button>
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-full shadow flex items-center justify-center gap-2 transition text-sm"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  Book Now
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ----- FOOTER WITH IMAGES ----- */}
      <footer className="bg-red-900 text-white py-6 sm:py-8 mt-6 sm:mt-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="text-2xl">{buildingIcon}</span>
            <p className="text-red-200/80 text-sm sm:text-base font-semibold">
              RS Mall &amp; Apartments · G-13/4 Islamabad
            </p>
          </div>
          <p className="text-xs sm:text-sm text-red-300/60 mt-1">
            “We deliver what we commit” — Red Sun Associates
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-3 text-red-300/70 text-xs sm:text-sm">
            <span className="flex items-center gap-1">📞 +92 348 7172565</span>
            <span className="flex items-center gap-1">
              🏢 3 Decades of Trust
            </span>
            <span className="flex items-center gap-1">
              📍 Zone I, Islamabad
            </span>
          </div>
          <div className="mt-4 pt-4 border-t border-red-800/50 text-[10px] sm:text-xs text-red-400/50">
            © 2026 Red Sun Associates (Pvt) Ltd. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RSMall;
